export default __webpack_public_path__ + "static/media/download.73937c46.svg";